import { useState } from 'react';
import {
  Box,
  Paper,
  TextField,
  InputAdornment,
  IconButton
} from '@mui/material';
import ImageSearchModal from '../Modals/ImageSearchModal';
import ImageSearchIcon from '@mui/icons-material/ImageSearch';
import ImageSearchListing from './ImageSearchListing';

const ImageSearch = () => {
  const [uploadedImageData, setUploadedImageData] = useState(null);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);

  const handleUploadModalOpen = () => {
    setIsUploadModalOpen(true);
  };

  const handleUploadModalClose = () => {
    setIsUploadModalOpen(false);
  };

  const handleLasts = (data) => {
    setUploadedImageData(data);
  };

  return (
    <>
      <Paper sx={{ p: 2, border: 'none', boxShadow: 'none' }}>
        
        <Box
          sx={{
            maxWidth: 700,
            margin: '0 auto',
            mb: 2,
          }}
        >
          <TextField
            fullWidth
            id="searchForExclusiveImage"
            variant="outlined"
            placeholder="Search By Image"
            sx={{
              bgcolor: '#E5F5FF',
              borderRadius: '16px',
              cursor: 'pointer',
              '& .MuiOutlinedInput-root': {
                borderRadius: '16px',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
              },
            }}
            InputProps={{
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="open image search modal"
                    onClick={handleUploadModalOpen}
                    edge="end"
                    sx={{
                      '&:hover': {
                        backgroundColor: 'transparent',
                      },
                    }}
                  >
                    <ImageSearchIcon sx={{ color: 'action.active' }} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <ImageSearchListing />

        <ImageSearchModal
          open={isUploadModalOpen}
          handleOpen={handleUploadModalClose}
          handleLast={handleLasts}
        />
      </Paper>
    </>
  );
};

export default ImageSearch;